import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { LoginService } from './login.service';

@Injectable()
export class ContractInterceptor implements HttpInterceptor {
  private showingContractAlert = false;

  constructor(private loginService: LoginService, private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.isContractBlocked(error)) {
          this.showContractBlockedAlert(error.error?.mensaje || 'El contrato de la empresa ha finalizado y el acceso al sistema esta bloqueado hasta renovar el contrato.');
        }

        return throwError(() => error);
      })
    );
  }

  private isContractBlocked(error: HttpErrorResponse): boolean {
    const headerBlocked = error.headers?.get('X-Contract-Blocked') === 'true';
    const responseBlocked = error.status === 403 && error.error?.codigoError === 403;
    const message = (error.error?.mensaje || '').toLowerCase();
    return headerBlocked || (responseBlocked && message.includes('contrato'));
  }

  private showContractBlockedAlert(message: string) {
    if (this.showingContractAlert) {
      return;
    }

    this.showingContractAlert = true;
    Swal.fire({
      icon: 'error',
      title: 'Contrato finalizado',
      html: `<div style="text-align:left;line-height:1.5">${message}</div>`,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#4f4035',
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then(() => {
      const identity = this.loginService.getIdentity();
      if (identity?.correo) {
        identity.boton = true;
        this.loginService.CierraSesion(identity).subscribe({
          next: () => this.finalizaSesionBloqueada(),
          error: () => this.finalizaSesionBloqueada()
        });
        return;
      }

      this.finalizaSesionBloqueada();
    });
  }

  private finalizaSesionBloqueada() {
    this.loginService.limpiaSesion();
    this.showingContractAlert = false;
    this.router.navigate(['/authentication/login']);
  }
}